module.exports = __webpack_public_path__ + "static/media/24-5.f816c17c.mp3";